import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import * as React from 'react';

var SvgInkAvatarPlaceholder = function SvgInkAvatarPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: false
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 1c3.796 0 6.875 2.985 6.875 6.667 0 1.974-.885 3.747-2.291 4.968C20.37 14.32 23 18.03 23 22.333V25H1v-2.667c0-4.304 2.63-8.013 6.416-9.699-1.406-1.22-2.291-2.993-2.291-4.967C5.125 3.985 8.204 1 12 1zm0 13.333c-4.55 0-8.25 3.588-8.25 8h16.5c0-4.412-3.7-8-8.25-8zm0-10.8c-2.35 0-4.262 1.855-4.262 4.134C7.738 9.945 9.65 11.8 12 11.8c2.35 0 4.262-1.855 4.262-4.133 0-2.279-1.912-4.134-4.262-4.134z",
    fillRule: "evenodd"
  }));
};

export default SvgInkAvatarPlaceholder;